export const removeFalsy = obj => {
  const newObj = {};
  Object.keys(obj).forEach(key => {
    if (obj[key]) { newObj[key] = obj[key]; }
  });
  return newObj;
};

/**
 * Returns object based on url search params.
 * @param {string} queryString - search query.
 * @returns {Object} Search query state object.
 */

export const parseQueryState = queryString => {
  const params = new URLSearchParams(queryString);

  return Object.fromEntries(params.entries());
};

/**
 * Build search params
 * @param {string} params - current search params.
 * @param {Array|Object} newParams - new search params.
 * @returns {string} - merged search params
 */

export const getSearchParams = (params, newParams) => {
  let searchParams;

  if (!newParams) {
    return '';
  }

  if (Array.isArray(newParams)) {
    const parsedCurrUrl = parseQueryState(params);
    searchParams = new URLSearchParams({
      ...parsedCurrUrl,
      ...{ project: '', device: '', user: '' }
    });
    const param = {
      project: [],
      device: [],
      user: [],
      page: []
    };
    newParams.forEach(el => {
      const { type, value } = el;
      if (searchParams.has(type)) {
        param[type].push(value);
        searchParams.set(type, `${param[type].join(',')}`);
      } else {
        searchParams.set(type, value);
      }
    });
  } else {
    searchParams = new URLSearchParams(params);
    const { filterType, value, end, start } = newParams;

    if (filterType && value) {
      searchParams.set(filterType, value);
    }
    if (start && end) {
      searchParams.set('start', start);
      searchParams.set('end', end);
    }
  }

  const currentUrl = parseQueryState(params);
  const newUrl = parseQueryState(searchParams.toString());
  const mergedUrls = { ...currentUrl, ...newUrl };
  const url = new URLSearchParams(removeFalsy(mergedUrls));

  return `${url.toString()}`;
};
